import StickyBottomBarTrigger from "./StickyBottomBarTrigger";

export default StickyBottomBarTrigger;
